/**
 * Vraća formu na zadnje zapamćeno stanje.
 *
 * Ograničenja: jQueryUI Datepicker komponenta se neće vizualno ažurirati pa ju je potrebno ažurirati ručno.
 *
 * @param {object} $
 * @param {string} formId id forme za koju vraćamo stanje
 *
 * @return {object} sa dvije metode: rememberFormState() i restoreFormState()
 */
export function unconfiguredCreateFormStateHandler($, formId) {
    let lastFormState = null;

    return {
        rememberFormState() {
            const $form = $(`#${formId}`);
            const $disabledFields = $form.find(':disabled');

            $disabledFields.prop('disabled', false);
            lastFormState = $form.serializeArray();
            $disabledFields.prop('disabled', true);
        },
        restoreFormState() {
            const $form = $(`#${formId}`);
            if (lastFormState === null) {
                if (process.env.NODE_ENV !== 'production') {
                    // eslint-disable-next-line no-console
                    console.error(`Pokušaj vraćanja stanja forme "${formId}" za koju nije zapamćeno originalno stanje`);
                }

                return;
            }

            $form.find('input[type="checkbox"]').prop('checked', false);
            $form.find('input[type="radio"]').prop('checked', false);
            $form.find('select[multiple]').val('');

            lastFormState.forEach((data) => {
                const formToRestore = $form[0];
                const formElement = formToRestore.querySelector(`[name="${data.name}"]`);

                if (formElement.type === 'checkbox') {
                    const checkboxElements = formToRestore.querySelectorAll(`[name="${data.name}"]`);
                    checkboxElements.forEach((checkboxElement) => {
                        if (checkboxElement.value === data.value) {
                            checkboxElement.checked = true;
                        }
                    });
                } else if (formElement.type === 'radio') {
                    formToRestore.querySelector(`[value="${data.value}"]`).checked = true;
                } else if (formElement.tagName.toLowerCase() === 'select' && formElement.multiple === true) {
                    const optionElements = formElement.querySelectorAll('option');
                    optionElements.forEach((optionElement) => {
                        if (data.value === optionElement.value) {
                            optionElement.selected = data.value === optionElement.value;
                        }
                    });
                } else {
                    formElement.value = data.value;
                }
            });
        },
    };
}

export function createFormStateHandler(formId) {
    return unconfiguredCreateFormStateHandler($, formId);
}
